// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../api/types.generated';

import { gql } from '@apollo/client';
export type ProjectDetailFragment = (
  { readonly __typename: 'Project' }
  & Pick<Types.Project, 'id' | 'name' | 'type' | 'status' | 'isOwned' | 'cod' | 'ntp' | 'acquisitionDate' | 'ppaLength' | 'ppaRemainingAvg' | 'panelCount' | 'inverterCount' | 'offtakerName' | 'offtakerCredit' | 'moduleManufacturer' | 'inverterManufacturer' | 'acquiredPortfolio' | 'capacity' | 'capacityAc' | 'withinOneCount' | 'withinOneSumCapacityAc' | 'withinTenCount' | 'withinTenSumCapacityAc'>
  & { readonly spatial?: Types.Maybe<(
    { readonly __typename: 'ProjectSpatial' }
    & Pick<Types.ProjectSpatial, 'geoJsonUrl'>
    & { readonly features?: Types.Maybe<ReadonlyArray<(
      { readonly __typename: 'SpatialFeature' }
      & Pick<Types.SpatialFeature, 'id' | 'name' | 'type' | 'stroke' | 'strokeOpacity' | 'strokeWidth' | 'fill' | 'fillOpacity' | 'geoJsonUrl'>
    )>> }
  )>, readonly location: (
    { readonly __typename: 'ProjectLocation' }
    & Pick<Types.ProjectLocation, 'address' | 'city' | 'state' | 'zipCode' | 'elevation' | 'latitude' | 'longitude'>
  ), readonly system: (
    { readonly __typename: 'System' }
    & Pick<Types.System, 'system' | 'solarCapacityDc' | 'solarCapacityAc' | 'bessKw' | 'bessKwh' | 'installation' | 'mounting' | 'windTurbineCount' | 'windCapacityPerTurbineKw' | 'windHubHeightM' | 'windRotorDiameterM' | 'windTurbineManufacturer' | 'windTurbineModel' | 'windSiting'>
  ), readonly utility?: Types.Maybe<(
    { readonly __typename: 'Utility' }
    & Pick<Types.Utility, 'name' | 'zone' | 'iso'>
  )>, readonly withinOne?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'ProjectDict' }
    & Pick<Types.ProjectDict, 'id' | 'name'>
  )>>, readonly withinTen?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'ProjectDict' }
    & Pick<Types.ProjectDict, 'id' | 'name'>
  )>> }
);

export const ProjectDetailFragmentDoc = gql`
    fragment ProjectDetail on Project {
  id
  name
  type
  status
  isOwned
  cod
  ntp
  acquisitionDate
  ppaLength
  ppaRemainingAvg
  panelCount
  inverterCount
  offtakerName
  offtakerCredit
  moduleManufacturer
  inverterManufacturer
  acquiredPortfolio
  capacity
  capacityAc
  spatial {
    geoJsonUrl
    features {
      id
      name
      type
      stroke
      strokeOpacity
      strokeWidth
      fill
      fillOpacity
      geoJsonUrl
    }
  }
  location {
    address
    city
    state
    zipCode
    elevation
    latitude
    longitude
  }
  system {
    system
    solarCapacityDc
    solarCapacityAc
    bessKw
    bessKwh
    installation
    mounting
    windTurbineCount
    windCapacityPerTurbineKw
    windHubHeightM
    windRotorDiameterM
    windTurbineManufacturer
    windTurbineModel
    windSiting
  }
  utility {
    name
    zone
    iso
  }
  withinOne(portfolioIds: $portfolioIds, portfolioStatuses: $portfolioStatuses) {
    id
    name
  }
  withinTen(portfolioIds: $portfolioIds, portfolioStatuses: $portfolioStatuses) {
    id
    name
  }
  withinOneCount(
    portfolioIds: $portfolioIds
    portfolioStatuses: $portfolioStatuses
  )
  withinOneSumCapacityAc(
    portfolioIds: $portfolioIds
    portfolioStatuses: $portfolioStatuses
  )
  withinTenCount(
    portfolioIds: $portfolioIds
    portfolioStatuses: $portfolioStatuses
  )
  withinTenSumCapacityAc(
    portfolioIds: $portfolioIds
    portfolioStatuses: $portfolioStatuses
  )
}
    `;